import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getNotification = createAsyncThunk('notification/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/notification/get-notification`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getHeaderNotification = createAsyncThunk('notification/all-header', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/notification/get-unread-notifications`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRejectedCleaningNotification = createAsyncThunk('notification/rejected', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/notification/get-rejected-cleaning-notification`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCheckinCheckoutNotification = createAsyncThunk('notification/checkin-checkout', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/notification/get-notifications-checkin-checkout`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteNotification = createAsyncThunk('notification/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/notification/delete-notification/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateDeviceToken = createAsyncThunk('notification/device', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/update-device-token`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const readAllNotification = createAsyncThunk('notification/readAll', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/notification/read-all-notifications`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const readSingleNotification = createAsyncThunk('notification/readSingle', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/notification/read-notification/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const initialState = {
  isLoading: false,
  allNotification: [],
  allHeaderNotification: [],
  rejectedCleaningNotification: [],
  checkinCheckoutNotification: [],
  error: null
}

const NotificationSlice = createSlice({
  name: 'notification',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        state.isLoading = false
        state.allNotification = action.payload?.data?.data
      })
      .addCase(getNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getHeaderNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getHeaderNotification.fulfilled, (state, action) => {
        state.isLoading = false
        state.allHeaderNotification = action.payload?.data?.data
      })
      .addCase(getHeaderNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getRejectedCleaningNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRejectedCleaningNotification.fulfilled, (state, action) => {
        state.isLoading = false
        state.rejectedCleaningNotification = action.payload?.data?.data
      })
      .addCase(getRejectedCleaningNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCheckinCheckoutNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCheckinCheckoutNotification.fulfilled, (state, action) => {
        state.isLoading = false
        state.checkinCheckoutNotification = action.payload?.data?.data
      })
      .addCase(getCheckinCheckoutNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteNotification.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateDeviceToken.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateDeviceToken.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateDeviceToken.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(readAllNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(readAllNotification.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(readAllNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(readSingleNotification.pending, (state) => {
        state.isLoading = true
      })
      .addCase(readSingleNotification.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(readSingleNotification.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default NotificationSlice.reducer
